/* istanbul ignore file */
import { FormSection, FormRow } from 'framework/ui/layout';
import { DateInput, TextInput } from 'framework/form';
import { AccountNameInput } from 'domain/shared/account';
import ArtifactStorageTypeDropdown from 'domain/documents/artifactStorage/shared/input/ArtifactStorageTypeDropdown';
import { useAuthorization } from 'framework/authorization';
import ArtifactStorageFileInput from 'domain/documents/artifactStorage/shared/input/ArtifactStorageFileInput';
import { ServiceInput } from 'domain/shared/service';
import {
  ArtifactFileType,
  ArtifactFileTypeLabel,
  ArtifactSowInput,
  ATTACH_ARTIFACT,
  ArtifactStorageUploaderInput,
} from 'domain/shared/artifactStorage';

const ArtifactStorageForm = () => {
  const { isGranted } = useAuthorization();

  const getOptions = () => {
    return Object.entries(ArtifactFileTypeLabel)
      .filter(([value, label]: string[]) => isGranted(`ARTIFACT_STORAGE_FILE_UPLOAD_${value}`))
      .map(([value, label]: string[]) => ({ label, value }));
  };

  return (
    <FormSection title="Artifact information">
      <FormRow>
        <ArtifactStorageTypeDropdown source="type" options={getOptions()} />
        <AccountNameInput
          source="relatedAccount"
          label="Related account"
          accountNameValue=""
          accountNameSource="accountName"
          isVisible={data =>
            isGranted(ATTACH_ARTIFACT) && data.type !== ArtifactFileType.COMPANY_SERVICE_BUDGET && data.type != null
          }
        />
        <ServiceInput
          source="relatedService"
          label="Related service"
          searchString="name"
          isVisible={data => isGranted(ATTACH_ARTIFACT) && data.type === ArtifactFileType.COMPANY_SERVICE_BUDGET}
        />
      </FormRow>
      <FormRow>
        <TextInput
          source="sowNumber"
          label="SOW number"
          isVisible={data => data.type === ArtifactFileType.STATEMENT_OF_WORK}
        />
        <TextInput
          source="changeRequestNumber"
          label="Change request number"
          isVisible={data => data.type === ArtifactFileType.CHANGE_REQUEST}
        />
        <TextInput source="msaNumber" label="MSA Number" isVisible={data => data.type === ArtifactFileType.MSA} />
        <TextInput
          source="amendmentNumber"
          label="Amendment number"
          isVisible={data => data.type === ArtifactFileType.AMENDMENT}
        />
        <DateInput
          source="acceptanceFromDate"
          label="Acceptance from date"
          isVisible={data => data.type === ArtifactFileType.ACCEPTANCE}
        />
        <DateInput
          source="acceptanceToDate"
          label="Acceptance to date"
          isVisible={data => data.type === ArtifactFileType.ACCEPTANCE}
        />
        <ArtifactSowInput
          source="sow"
          label="SOW"
          isVisible={data =>
            isGranted(ATTACH_ARTIFACT) &&
            (data.type === ArtifactFileType.CHANGE_REQUEST ||
              data.type === ArtifactFileType.ACCEPTANCE ||
              data.type === ArtifactFileType.AMENDMENT)
          }
          showMetaInfo
          errorSource="artifactRelation"
        />
        <ArtifactStorageFileInput
          source="sow"
          label="SOW"
          customPlaceholder="Select SOW"
          relationClass="ArtifactStorageFile"
          showMetaInfo
          showRelationToClass="Account"
          searchType={ArtifactFileType.STATEMENT_OF_WORK}
          isVisible={data =>
            !isGranted(ATTACH_ARTIFACT) &&
            (data.type === ArtifactFileType.CHANGE_REQUEST || data.type === ArtifactFileType.ACCEPTANCE)
          }
        />
        <TextInput
          source="budgetName"
          label="Budget name"
          isVisible={data => data.type === ArtifactFileType.COMPANY_SERVICE_BUDGET}
        />
      </FormRow>
      <FormRow>
        <ArtifactStorageUploaderInput source="artifactId" label="File" />
      </FormRow>
    </FormSection>
  );
};

export default ArtifactStorageForm;
